"use strict";
(self.webpackChunkNeptuneTheme2 = self.webpackChunkNeptuneTheme2 || []).push([
  [610],
  {
    994: () => {
      function t(t) {
        return (
          (function (t) {
            if (Array.isArray(t)) return n(t);
          })(t) ||
          (function (t) {
            if (
              ("undefined" != typeof Symbol && null != t[Symbol.iterator]) ||
              null != t["@@iterator"]
            )
              return Array.from(t);
          })(t) ||
          e(t) ||
          (function () {
            throw new TypeError(
              "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          })()
        );
      }
      function e(t, e) {
        if (t) {
          if ("string" == typeof t) return n(t, e);
          var o = Object.prototype.toString.call(t).slice(8, -1);
          return (
            "Object" === o && t.constructor && (o = t.constructor.name),
            "Map" === o || "Set" === o
              ? Array.from(t)
              : "Arguments" === o ||
                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o)
              ? n(t, e)
              : void 0
          );
        }
      }
      function n(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for (var n = 0, o = new Array(e); n < e; n++) o[n] = t[n];
        return o;
      }
      var o = {
        config: { delay: 100 },
        data: {},
        timer: 2e3,
        init: function () {
          _n.exists("[data-collection-filters]") &&
            (o.start(),
            o.bindURL(),
            Neptune.liquid.load("activeFilters"),
            Collection.init());
        },
        start: function () {
          (Collection.loader.firstRender = !0),
            _n.qsa("form[data-collection-filters] input").forEach(function (t) {
              t.addEventListener("input", function (t) {
                _n.qs(".collection-products").classList.add("loading"),
                  o.timer && clearTimeout(o.timer),
                  (o.timer = setTimeout(function () {
                    o.value(),
                      Collection.reset
                        ? (Collection.reset(),
                          setTimeout(Collection.reset, 50),
                          setTimeout(Collection.load, 100))
                        : Neptune.templates.render("Products", Collection),
                      _n.qs(".collection-products").classList.remove("loading");
                  }, 1e3));
              });
            }),
            Neptune.liquid.load("activeFilters");
        },
        value: function () {
          var t,
            n = {},
            a = (function (t, n) {
              var o =
                ("undefined" != typeof Symbol && t[Symbol.iterator]) ||
                t["@@iterator"];
              if (!o) {
                if (Array.isArray(t) || (o = e(t))) {
                  o && (t = o);
                  var a = 0,
                    r = function () {};
                  return {
                    s: r,
                    n: function () {
                      return a >= t.length
                        ? { done: !0 }
                        : { done: !1, value: t[a++] };
                    },
                    e: function (t) {
                      throw t;
                    },
                    f: r,
                  };
                }
                throw new TypeError(
                  "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
                );
              }
              var i,
                l = !0,
                c = !1;
              return {
                s: function () {
                  o = o.call(t);
                },
                n: function () {
                  var t = o.next();
                  return (l = t.done), t;
                },
                e: function (t) {
                  (c = !0), (i = t);
                },
                f: function () {
                  try {
                    l || null == o.return || o.return();
                  } finally {
                    if (c) throw i;
                  }
                },
              };
            })(new FormData(_n.qs("form[data-collection-filters]")).entries());
          try {
            for (a.s(); !(t = a.n()).done; ) {
              var r = t.value;
              void 0 === n[r[0]] && (n[r[0]] = { tags: [] }),
                n[r[0]].tags.push(r[1]),
                (n[r[0]].constraint =
                  _n
                    .qs(
                      'form[data-collection-filters] [data-constraint][name="'.concat(
                        r[0],
                        '"]'
                      )
                    )
                    .getAttribute("data-constraint") || !1),
                (n[r[0]].field =
                  _n
                    .qs(
                      'form[data-collection-filters] [data-constraint][name="'.concat(
                        r[0],
                        '"]'
                      )
                    )
                    .getAttribute("data-field") || "~tags");
            }
          } catch (t) {
            a.e(t);
          } finally {
            a.f();
          }
          return (o.data = n), o.bindURL(o.data), n;
        },
        clear: function (t) {
          if ((console.log(t), t)) {
            (t.value = decodeURIComponent(t.value)),
              (_n.qs('[value="' + t.value + '"]').checked = !1);
            var e = o.data[t.set].tags
              .map(decodeURIComponent)
              .filter(function (e) {
                return e != t.value;
              });
            console.log("removed tags", e),
              0 == e.length ? delete o.data[t.set] : (o.data[t.set].tags = e),
              o.bindURL(o.data);
          } else
            (o.data = {}),
              (o.flat_data = []),
              _n
                .qsa("[data-collection-filters] input[type=checkbox]")
                .forEach(function (t) {
                  t.checked = !1;
                });
          o.bindURL(o.data),
            Collection.reset
              ? (Collection.reset(), setTimeout(Collection.load, 20))
              : Neptune.templates.render("Products");
        },
        bindURL: function (e) {
          if (!e) {
            (o.data = {}), (o.flat_data = []);
            try {
              document.location.href
                .split("?")[1]
                .split("&")
                .forEach(function (t) {
                  var e = t.split("=");
                  if (-1 == e[0].indexOf("filter[")) return !1;
                  var n = e[0].split("[")[1].split("]")[0],
                    a = n;
                  n.includes("~") && (n = n.split("~")[0]),
                    n
                      ? (o.data[n] = { tags: e[1].split(","), field: a })
                      : e[1].split(",").forEach(function (t) {
                          o.flat_data.push(t);
                        });
                });
            } catch (t) {}
            return (
              _n
                .qsa("[data-collection-filters] input[type=checkbox]")
                .forEach(function (t) {
                  t.checked = !1;
                }),
              Object.keys(o.data).forEach(function (t) {
                o.data[t].tags.map(function (t) {
                  (t = decodeURIComponent(t)),
                    _n.exists('[value="'.concat(t, '"]')) &&
                      (_n.qs('[value="'.concat(t, '"]')).checked = !0);
                });
              }),
              o.flat_data.forEach(function (t) {
                (t = t.replace("%20", " ")),
                  _n.exists('[value="'.concat(t, '"]')) &&
                    (_n.qs('[value="'.concat(t, '"]')).checked = !0);
              }),
              (o.native = []),
              document.location.pathname.split("/").length >= 4 &&
                ((o.native = document.location.pathname
                  .split("/")[3]
                  .split("+")),
                _n
                  .qsa("[data-collection-filters] input")
                  .filter(function (t) {
                    return document.location.pathname
                      .split("/")[3]
                      .split("+")
                      .includes(
                        t.dataset.field.split("~")[0].handle() +
                          "-" +
                          t.value.handle()
                      );
                  })
                  .forEach(function (t) {
                    t.checked = !0;
                    var e = t.dataset.field.split("~")[0];
                    o.data[e] ||
                      (o.data[e] = { tags: [], field: t.dataset.field }),
                      o.data[e].tags.push(t.value);
                  })),
              _n.exists(".filter-format-range .ghost") &&
                _n.qsa(".filter-format-range").forEach(function (e) {
                  var n = _n
                      .array(_n.qsa("input[type=checkbox]", e))
                      .map(function (t, e) {
                        if (t.checked) return e + 1;
                      })
                      .filter(function (t) {
                        return null != t;
                      }),
                    o = Math.min.apply(Math, t(n)),
                    a = Math.max.apply(Math, t(n)),
                    r = _n.qs(".multirange.original");
                  r.value = o + "," + a;
                  var i = _n.qs(".multirange.ghost");
                  i.style.setProperty(
                    "--low",
                    ((r.valueLow - r.min) / (r.max - r.min)) * 100 + 1 + "%"
                  ),
                    i.style.setProperty(
                      "--high",
                      ((r.valueHigh - r.min) / (r.max - r.min)) * 100 - 1 + "%"
                    );
                }),
              o.data
            );
          }
          console.log(e),
            (o.native = Object.values(o.data)
              .filter(function (t) {
                return (
                  1 == t.tags.length &&
                  !window.pseudoCollection &&
                  !window.tagFiltered &&
                  !window.searchPerformed
                );
              })
              .map(function (t) {
                return ""
                  .concat(t.field.split("~")[0], "-")
                  .concat(t.tags[0])
                  .handle();
              })),
            (o.advanced = Object.values(o.data)
              .filter(function (t) {
                return (
                  t.tags.length > 1 ||
                  !!window.tagFiltered ||
                  !!window.searchPerformed
                );
              })
              .map(function (t) {
                return "filter[".concat(t.field, "]=").concat(
                  t.tags.map(function (t) {
                    return t
                      .split(
                        window.filter_delimiter ? window.filter_delimiter : ":"
                      )
                      .reverse()[0];
                  })
                );
              })),
            (o.search =
              "".concat(
                _n.urlparams.get("q") ? "q=".concat(_n.urlparams.get("q")) : ""
              ) || !1);
          var n = 3;
          pseudoCollection && (n = 4),
            tagFiltered && (n = 4),
            searchPerformed && (n = 2);
          var a = ""
            .concat(
              document.location.pathname
                .split("/")
                .slice(0, n)
                .join("/")
                .replace(/\/$/, "")
            )
            .concat(o.native.length ? "/".concat(o.native.join("+")) : "")
            .concat(o.advanced.length ? "?".concat(o.advanced.join("&")) : "");
          o.search &&
            (a += "".concat(o.advanced.length ? "&" : "?").concat(o.search)),
            (console.log('122222222222333',a)),
            (console.log('55555',o)),
            window.history.replaceState(
              window.history.state || {},
              document.title,
              a
            ),
            Neptune.liquid.load("activeFilters");
        },
      };
      window.Filters = o;
      const a = o;
      function r(t) {
        return (
          (function (t) {
            if (Array.isArray(t)) return i(t);
          })(t) ||
          (function (t) {
            if (
              ("undefined" != typeof Symbol && null != t[Symbol.iterator]) ||
              null != t["@@iterator"]
            )
              return Array.from(t);
          })(t) ||
          (function (t, e) {
            if (t) {
              if ("string" == typeof t) return i(t, e);
              var n = Object.prototype.toString.call(t).slice(8, -1);
              return (
                "Object" === n && t.constructor && (n = t.constructor.name),
                "Map" === n || "Set" === n
                  ? Array.from(t)
                  : "Arguments" === n ||
                    /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
                  ? i(t, e)
                  : void 0
              );
            }
          })(t) ||
          (function () {
            throw new TypeError(
              "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          })()
        );
      }
      function i(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for (var n = 0, o = new Array(e); n < e; n++) o[n] = t[n];
        return o;
      }
      var l = {
        config: {},
        products: [],
        deferred_products: [],
        all_tags: [],
        badges: window.productBadges || [],
        loader: {
          url: "",
          data_source: "server",
          isLoading: !1,
          firstRender: !0,
          page: 1,
          pages: 0,
          startBatchIndex: 0,
          pendingBatchIndex: 0,
          loadedBatches: [],
          activeProducts: [],
          controllers: [],
        },
        pagination: {
          products: 0,
          page_size: 0,
          pages: [1],
          total_pages: 1,
          current_page: 1,
        },
        store: function (t, e, n) {
          try {
            sessionStorage.setItem(
              t + ":" + document.location.href,
              JSON.stringify(e)
            );
          } catch (t) {}
          0 != n &&
            Object.keys(sessionStorage).forEach(function (e) {
              e.includes(t + ":") &&
                e != t + ":" + document.location.href &&
                sessionStorage.removeItem(e);
            });
        },
        recall: function (t, e) {
          return l.config.session_storage &&
            sessionStorage.getItem(t + ":" + document.location.href)
            ? JSON.parse(
                sessionStorage.getItem(t + ":" + document.location.href)
              )
            : e || !1;
        },
        load: async function () {
          l.loader.isLoading = true;
          l.doSubsort = false;

          if (
            l.subsort &&
            Object.keys(a.data).length === 0 &&
            _n.urlparams.get().sort_by &&
            _n.urlparams.get().sort_by !== "featured" &&
            !l.subsort[0].ran
          ) {
            l.doSubsort = true;
          }

          const currentSortBy = _n.urlparams.get().sort_by;
          if (currentSortBy && currentSortBy !== l.lastSortBy) {
            l.products = [];
            l.deferred_products = [];
            l.loader.page = 1;
            l.lastSortBy = currentSortBy;
          }

          if (
            l.config.session_storage &&
            l.products.length === 0 &&
            !currentSortBy
          ) {
            l.products = l.recall("products", []);
            l.all_tags = l.recall("all_tags", []);
            if (l.products.length > 0) {
              _n.trigger(document, "collection:allProductsLoaded");
              Neptune.liquid.load("AllProducts", l);
              l.loader.data_source = "session";
              l.paginate();
              l.render();
              return l.products.length;
            }
          }

          let queryParams = "";
          let isFilter = false;
          if (document.location.href.split("?").length > 1) {
            queryParams = "&" + document.location.href.split("?")[1];
            if (queryParams.indexOf("&filter") > -1) {
              isFilter = true;
            }
          }

          if(isFilter) {
            queryParams = "&filter[]=" + (await l.formatFilterUrl(queryParams));
          }

          if (!isFilter) {
            queryParams += "&page_size=" + l.pagination.page_size;
          }
          
          if (currentSortBy && !queryParams.includes("sort_by") || document.querySelector("#Sortbtn").value !== "featured") {
            if(!_n.urlparams.get().sort_by) {
              queryParams += "&sort_by=" + document.querySelector("#Sortbtn").value;
            }
          }
   
          // const url = `${document.location.pathname}?view=feed${queryParams}&type=product&page=${l.pagination.current_page}&page_size=${l.pagination.page_size}`;
          const url = `${document.location.pathname}?view=feed${queryParams}&include_variants=true&type=product&page=${l.pagination.current_page}`;
          // const url = `${document.location.pathname}?view=feed&q=bike,tag:engr:max user weight:220 lb&type=product&page=${l.pagination.current_page}&page_size=${l.pagination.page_size}`;
          // const url = `${document.location.pathname}?view=feed&filter[]=${encodeURIComponent('engr:max user weight:220 lb')},${encodeURIComponent('engr:max user weight:300 lb')}&q=bike&type=product&page=${l.pagination.current_page}`;
          // const url = `${document.location.pathname}?view=feed${decodeURIComponent(queryParams)}&type=product&page=${l.pagination.current_page}`;
          l.loader.url = url;

          console.log('11111111111', url)

          const controller = new AbortController();
          l.loader.controllers.push(controller);

          fetch(url, { signal: controller.signal })
            .then((response) => response.json())
            .then((data) => {
              if (l.loader.url !== url) return false;

              data.products = data.products.filter((product) => !!product);

              if (l.loader.page === 1 || currentSortBy) {
                l.products = [];
              }

              if (
                l.config.ignore_defer_sale.split(",").includes(l.handle) ||
                (currentSortBy && currentSortBy !== "featured")
              ) {
                l.products = l.products.concat(data.products);
              } else {
                l.products = l.products.concat(data.products);
                // l.products = l.products.concat(
                //   data.products.filter((product) => !product.available)
                // );
                // l.deferred_products = l.deferred_products.concat(
                //   data.products.filter((product) => product.available)
                // );
              }

              l.all_tags = _n.unique([
                ...l.all_tags,
                ..._n.flatten(data.products.map((p) => p.tags)),
              ]);

              l.loader.pages = data.pagination?.collection?.pages || 1;

              // if (
              //   (data.pagination?.collection?.current_page < l.loader.pages) ||
              //   l.doSubsort
              // ) {
              //   if (l.doSubsort) {
              //     l.subsort[0].ran = true;
              //     l.subsort[0].products = data.products.map((p) => p.id);
              //   console.log('fffff',l)
              //   } else {
              //   console.log('rrrrr',l)
              //     l.loader.page++;
              //   }
              //   _n.trigger(document, "collection:productsLoaded");
              //   console.log('33333',l)
              //   // l.load();
              // } else {
              //   console.log('444444444444',l)

              //   l.products = l.products.concat(l.deferred_products);
              //   _n.trigger(document, "collection:allProductsLoaded");
              //   Neptune.liquid.load("AllProducts", l);
              //   if (l.config.session_storage && !currentSortBy) {
              //     l.store("products", l.products);
              //     l.store("all_tags", l.all_tags);
              //   }
              // }

              typeof Shopify !== "undefined" && l.reGenProductsSubTypeTitle();
              setTimeout(function () {
                l.paginate();
                l.render();
              }, 0);

              //     l.handlerProductVideo();
            })
            .catch((error) => {
              if (error.name !== "AbortError") {
                console.error("Fetch error:", error);
              }
            });
        },

        formatFilterUrl: function (url) {
          url = decodeURIComponent(url);
          let parts = url.split("&");

          let filterData = parts.filter((item) => item.startsWith("filter["));
          let otherParams = parts.filter((item) => !item.startsWith("filter["));

          let filterPromise = Promise.resolve("");
          if (filterData.length > 0) {
            filterPromise = Promise.all(
              filterData.map((item) => l.genFilterValue(item))
            ).then((results) => {
              return results.flat().join(",");
            });
          }

          return filterPromise.then((filterString) => {
            let resultParts = [];
            if (filterString) resultParts.push(filterString);
            if (otherParams.length > 0) {
              resultParts.push(otherParams.join("&"));
            }
            return resultParts.join("&");
          });
        },

        genFilterValue: function (item) {
          return new Promise((resolve) => {
          let [keyPart, valuePart] = item.split("=");
          let values = valuePart.split(",");
          const match = keyPart.match(/\[(.*?):?~tags\]/);
          const key = match ? match[1] : '';
        
          let encodedValues = values.map(value => {
          const fullValue = key.includes(':') ? `${key}:${value}` : `${key}:${value}`;
          return encodeURIComponent(fullValue);
          });
  
            resolve(encodedValues);
          });
        },
        handlerProductVideo: function () {
          const productVideoManager = {
            currentPlayingVideo: null,
            observer: null,
            isScrolling: false,
            scrollEndTimer: null,
            videoElements: [],

            init: function () {
              this.setupScrollHandler();
              this.setupIntersectionObserver();
              this.setupHoverEvents();
            },

            setupScrollHandler: function () {
              let lastScrollPos = window.pageYOffset;
              let ticking = false;

              window.addEventListener(
                "scroll",
                () => {
                  lastScrollPos = window.pageYOffset;

                  if (!ticking) {
                    window.requestAnimationFrame(() => {
                      this.handleScroll(lastScrollPos);
                      ticking = false;
                    });
                    ticking = true;
                  }

                  this.isScrolling = true;
                  clearTimeout(this.scrollEndTimer);
                  this.scrollEndTimer = setTimeout(() => {
                    this.isScrolling = false;
                  }, 1200);
                },
                { passive: true }
              );
            },

            handleScroll: function () {
              if (this.currentPlayingVideo) {
                this.currentPlayingVideo.pause();
                this.currentPlayingVideo.currentTime = 0;
                this.currentPlayingVideo = null;
              }
            },

            setupIntersectionObserver: function () {
              if (this.observer) return;

              this.observer = new IntersectionObserver(
                (entries) => {
                  entries.forEach((entry) => {
                    const videoContainer = entry.target;
                    const video = videoContainer.querySelector("video");

                    if (entry.isIntersecting) {
                      this.loadVideo(videoContainer);
                    } else {
                      if (video && !video.paused) {
                        video.pause();
                        video.currentTime = 0;
                      }
                    }
                  });
                },
                {
                  rootMargin: "300px",
                  threshold: 0.85,
                }
              );

              document
                .querySelectorAll(".product-image__hover")
                .forEach((el) => {
                  this.observer.observe(el);
                  this.videoElements.push(el);
                });
            },

            loadVideo: function (container) {
              if (
                container.dataset.videoLoaded ||
                !container.hasAttribute("data-video")
              )
                return;

              const videoSrc = container.getAttribute("data-video");
              const videoElement = container.querySelector("video");
              if (!videoElement) return;

              container.dataset.videoLoading = "true";

              const source = document.createElement("source");
              source.src = videoSrc;
              source.type = "video/mp4";

              const fragment = document.createDocumentFragment();
              fragment.appendChild(source);

              videoElement.preload = "auto";
              videoElement.playsInline = true;

              videoElement.innerHTML = "";
              videoElement.appendChild(source);

              const onLoaded = () => {
                container.dataset.videoLoaded = "true";
                container.dataset.videoLoading = "false";
                videoElement.removeEventListener("loadedmetadata", onLoaded);
                videoElement.removeEventListener("error", onError);
              };

              const onError = () => {
                container.dataset.videoLoading = "false";
                this.showFallbackImage(container);
                videoElement.removeEventListener("loadedmetadata", onLoaded);
                videoElement.removeEventListener("error", onError);
              };

              videoElement.addEventListener("loadedmetadata", onLoaded, {
                once: true,
              });
              videoElement.addEventListener("error", onError, { once: true });
            },

            showFallbackImage: function (container) {
              const video = container.querySelector("video");
              const fallback = container.querySelector(".fallback-image");

              if (video) video.style.display = "none";
              if (fallback) fallback.style.display = "block";
            },

            setupHoverEvents: function () {
              const container = document.querySelector(".collection-products");
              if (!container) return;

              container.addEventListener(
                "mouseover",
                (e) => {
                  if (this.isScrolling) return;

                  const hoverEl = e.target.closest(".product-image__hover");
                  if (hoverEl && hoverEl.dataset.videoLoaded) {
                    this.playVideo(hoverEl);
                  }
                },
                { passive: true }
              );

              container.addEventListener(
                "mouseout",
                (e) => {
                  const relatedTarget = e.relatedTarget;
                  if (
                    !relatedTarget ||
                    !relatedTarget.closest(".product-image__hover")
                  ) {
                    this.pauseCurrentVideo();
                  }
                },
                { passive: true }
              );
            },

            playVideo: function (container) {
              const video = container.querySelector("video");
              if (!video || video.readyState < 2) return; // HAVE_METADATA

              if (
                this.currentPlayingVideo &&
                this.currentPlayingVideo !== video
              ) {
                this.pauseCurrentVideo();
              }

              video.currentTime = 0;
              video.muted = true;

              const playPromise = video.play();
              if (playPromise !== undefined) {
                playPromise
                  .then(() => {
                    this.currentPlayingVideo = video;
                  })
                  .catch(() => {
                    // console.log("--------- 自动播放被阻止，添加点击播放后备");
                    container.style.cursor = "pointer";
                    container.addEventListener("click", this.handleVideoClick, {
                      once: true,
                    });
                  });
              }
            },

            handleVideoClick: function (e) {
              const container = e.currentTarget;
              const video = container.querySelector("video");
              if (video) {
                video
                  .play()
                  .then(() => {
                    container.style.cursor = "";
                  })
                  .catch(() => {
                    this.showFallbackImage(container);
                  });
              }
            },

            pauseCurrentVideo: function () {
              if (this.currentPlayingVideo) {
                this.currentPlayingVideo.pause();
                this.currentPlayingVideo.currentTime = 0;
                this.currentPlayingVideo = null;
              }
            },
          };

          requestAnimationFrame(() => {
            productVideoManager.init();
          });
        },
        reGenProductsSubTypeTitle: function () {
          if (!Shopify.blogMenuTags) return;
          l.products.map((item) => {
            let filterPrefixes = ["comf:", "conv:", "engr:", "tech:"];
            const filteredTags = item.tags
              ? item.tags.filter(
                  (tag) =>
                    !filterPrefixes.some((prefix) =>
                      tag.toLowerCase().startsWith(prefix)
                    )
                )
              : [];
            return {
              ...item,
              tags: filteredTags,
            };
          });
          l.products = l.categorizeProducts(l.products, Shopify.blogMenuTags);
        },
        categorizeProducts: function (products, subNavOrder) {
          // console.log("subNavOrder: ", subNavOrder);
          // console.log("products: ", products);
          const categorizedProducts = [];

          products.forEach((product) => {
            let foundCategory = false;
            if (product.tags && Array.isArray(product.tags)) {
              product.tags.forEach((tag) => {
                if (
                  subNavOrder &&
                  Array.isArray(subNavOrder) &&
                  typeof tag === "string" &&
                  subNavOrder.includes(tag)
                ) {
                  categorizedProducts.push({ ...product, subType: tag });
                  foundCategory = true;
                }
              });
            }

            if (!foundCategory && subNavOrder && Array.isArray(subNavOrder)) {
              categorizedProducts.push({ ...product, subType: "other" });
            }

            if (!subNavOrder) {
              categorizedProducts.push({
                ...product,
                subType: product.type || "unknown",
              });
            }
          });

          categorizedProducts.sort((a, b) => {
            if (a.subType === "other") return 1;
            if (b.subType === "other") return -1;

            if (subNavOrder && Array.isArray(subNavOrder)) {
              const indexA = subNavOrder.indexOf(a.subType);
              const indexB = subNavOrder.indexOf(b.subType);
              if (indexA === -1 && indexB === -1) return 0;
              if (indexA === -1) return 1;
              if (indexB === -1) return -1;
              return indexA - indexB;
            } else {
              return String(a.subType).localeCompare(String(b.subType));
            }
          });

          return categorizedProducts;
        },
        page: function (t, e) {
          console.log("Pagination request for page:", t);
          console.log("Current pagination state:", {
            current_page: l.pagination.current_page,
            total_pages: l.pagination.total_pages,
            total_products: l.products.length,
            page_size: l.config.page_size,
          });

          if (t < 1 || t > l.pagination.total_pages) {
            console.error("Invalid page number:", t);
            return false;
          }

          l.loader.pendingBatchIndex = t - 1;

          l.render();

          if (e) {
            const collectionElement = _n.qs(".collection-products");
            if (collectionElement) {
              window.scrollTo({
                top: collectionElement.getBoundingClientRect().top - 60,
                behavior: "auto",
              });
            }
          }

          l.pagination.current_page = l.loader.pendingBatchIndex + 1;
          console.log("page request for page:", l);
          l.load();
          Neptune.liquid.load("Pagination");

          const mainElement = _n.qs("main.collection-products");
          if (mainElement) {
            mainElement.setAttribute("tabindex", "-1");
            mainElement.focus();
          }

          return true;
        },

        render: function () {
          if (!l.products || l.products.length === 0) {
            const skeletonElement = _n.qs(".collection-container [skeleton]");
            if (skeletonElement) {
              skeletonElement.remove();
            }
            l.loader.isLoading = false;
            l.preloader();
            return;
          }

          const pageIndex = l.loader.pendingBatchIndex;
          const pageSize = l.config.page_size;
          let startIndex = pageIndex * pageSize;
          let endIndex = (pageIndex + 1) * pageSize;

          let renderMode = "content";

          console.log("Rendering products:", {
            total_products: l.products.length,
            start_index: startIndex,
            end_index: endIndex,
            page_index: pageIndex,
            page_size: pageSize,
          });

          const currentActiveProducts = l.loader.activeProducts || [];

          if (
            currentActiveProducts.length > 0 &&
            currentActiveProducts.length < pageSize &&
            startIndex > 0 &&
            l.products.length > currentActiveProducts.length
          ) {
            renderMode = "append";
            const existingProducts = _n.qsa("[data-product-item]").length;
            startIndex = existingProducts;
            endIndex = existingProducts + pageSize;

            console.log("Appending products:", {
              existing_products: existingProducts,
              new_start: startIndex,
              new_end: endIndex,
            });
          }

          endIndex = Math.min(endIndex, l.products.length);

          // l.loader.activeProducts = l.products.slice(startIndex, endIndex);
          l.loader.activeProducts = l.products;

          if (l.loader.activeProducts.length) {
            Neptune.templates.load("Products", l, renderMode);
          } else {
            console.warn("No products to render for the current page");
          }

          const skeletonElement = _n.qs(".collection-container [skeleton]");
          if (skeletonElement) {
            skeletonElement.remove();
          }

          l.loader.isLoading = false;

          l.preloader();

          setTimeout(function () {
            _n.trigger(document, "collection:productsRendered");
          }, 50);
        },
        // page: function (t, e) {
        //   console.log('111111111111111', l)
        //   return (
        //     !(t < 1) &&
        //     !(t > l.pagination.total_pages) &&
        //     ((l.loader.pendingBatchIndex = t - 1),
        //     l.render(),
        //     e &&
        //       window.scrollTo({
        //         top:
        //           _n.qs(".collection-products").getBoundingClientRect().top -
        //           60,
        //         behavior: "auto",
        //       }),
        //     (l.pagination.current_page = l.loader.pendingBatchIndex + 1),
        //     Neptune.liquid.load("Pagination"),
        //     _n.qs("main.collection-products").setAttribute("tabindex", "-1"),
        //     void _n.qs("main.collection-products").focus())
        //   );
        // },
        // render: function () {
        //   var t = l.loader.pendingBatchIndex * l.config.page_size,
        //     e = (l.loader.pendingBatchIndex + 1) * l.config.page_size,
        //     n = "content";
        //   // console.log("render products", l.products.length, t, e, n);
        //   // console.log("render Shopify.blogMenuTags", Shopify.blogMenuTags);

        //   // console.log("-------- render products", l);
        //   var o = l.loader.activeProducts;
        //   console.log("-------- 1111111111111111", t, e);

        //   o.length > 0 &&
        //     o.length < l.config.page_size &&
        //     l.products.length > o.length &&
        //     ((n = "append"),
        //     (t = _n.qsa("[data-product-item]").length),
        //     (e = l.config.page_size)),
        //     (l.loader.activeProducts = l.products.slice(t, e)),
        //     l.loader.activeProducts.length &&
        //       Neptune.templates.load("Products", l, n),
        //     _n.exists(".collection-container [skeleton]") &&
        //       _n.qs(".collection-container [skeleton]").remove(),
        //     (l.loader.isLoading = !1),
        //     l.preloader(),
        //     setTimeout(function () {
        //       console.log("-------- 22222222", l);
        //       _n.trigger(document, "collection:productsRendered");
        //     }, 50);
        // },
        paginate: function () {
          (l.pagination.products = l.products.length),
            // (l.pagination.total_pages = Math.ceil(
            //   l.products.length / l.config.page_size
            // )),
            (l.pagination.total_pages = l.loader.pages),
            (l.pagination.page_size = l.config.page_size),
            (l.pagination.pages = _n.range(1, l.loader.pages)),
            Neptune.liquid.load("Pagination");
        },

        reset: function () {
          (l.subsort = window.collectionConfig.subsort || !1),
            (l.products = []),
            (l.deferred_products = []),
            (l.all_tags = []),
            l.loader.controllers.forEach(function (t, e) {
              t.abort(), l.loader.controllers.splice(e, 1);
            }),
            window.scrollTo({
              top:
                _n.qs(".collection-products").getBoundingClientRect().top - 60,
              behavior: "auto",
            }),
            (_n.qs(".collection-products").innerHTML = ""),
            (l.loader.activeProducts = []),
            (l.loader.loadedBatches = []),
            (l.loader.startBatchIndex = 0),
            (l.loader.pendingBatchIndex = 0),
            (l.loader.page = 1),
            (l.loader.pages = 0),
            (l.pagination.current_page = 1),
            (l.loader.scrollListener = !1),
            window.history.replaceState({}, document.title),
            (l.loader.firstRender = !0);
        },
        sort: function (t) {
          console.log("------------------- collection sort", t),
            window.history.replaceState(
              window.history.state,
              document.title,
              document.location.pathname + "?" + _n.urlparams.set("sort_by", t)
            ),
            l.reset(),
            l.load();
        },
        preloader: function () {
          var emptyEl = _n.qs("[data-empty-products]"),
            nextEl = _n.qs("[data-next-products]"),
            footerEl = _n.qs("#collectionEndless footer"),
            headerTitle = _n.qs(".collection-tools h1"),
            searchQuery =
              (_n.urlparams.get("q") ||
                (document.querySelector(".sy-search-tabs-nav") &&
                  document.querySelector(".sy-search-tabs-nav").dataset
                    .searchTerms) ||
                "")
                .trim(),
            isSearchAllEmpty =
              window.searchAllEmpty &&
              window.searchPerformed &&
              0 == l.products.length;

          if (headerTitle && !headerTitle.dataset.defaultTitle) {
            headerTitle.dataset.defaultTitle = headerTitle.textContent.trim();
          }

          if (isSearchAllEmpty && headerTitle) {
            headerTitle.textContent =
              "No results found for \u201c" + searchQuery + "\u201d";
            footerEl && (footerEl.style.display = "none");
            emptyEl &&
              ((emptyEl.style.display = "none"), emptyEl.classList.add("hidden"));
            document.body.classList.add("search-all-empty");
          } else if (headerTitle && headerTitle.dataset.defaultTitle) {
            headerTitle.textContent = headerTitle.dataset.defaultTitle;
            footerEl && (footerEl.style.display = "");
            document.body.classList.remove("search-all-empty");
          }

          l.loader.isLoading &&
          _n.qsa("[data-product-item]").length < l.config.page_size
            ? nextEl &&
              ((nextEl.style.display = "block"), nextEl.classList.add("loading"))
            : (nextEl &&
                ((nextEl.style.display = "none"), nextEl.classList.remove("loading")),
              0 == l.products.length && !isSearchAllEmpty
                ? (emptyEl &&
                    ((emptyEl.style.display = "block"),
                    emptyEl.classList.remove("hidden")),
                  nextEl &&
                    ((nextEl.style.display = "none"),
                    nextEl.classList.remove("loading")))
                : !isSearchAllEmpty &&
                  emptyEl &&
                  ((emptyEl.style.display = "none"), emptyEl.classList.add("hidden"))),
            _n.qs("#results") &&
              (_n.qs("#results").innerHTML =
                "<p>" + l.products.length + " results available</p>");
        },
        init: function () {
          (l.handle = document.location.pathname.split("/").reverse()[0]),
            (l.config = window.collectionConfig),
            (l.subsort = _n.copy(window.collectionConfig.subsort) || !1),
            (l.pagination.page_size = l.config.page_size),
            window.history.state &&
              window.history.state.batch &&
              1 != performance.navigation.type &&
              ((l.loader.startBatchIndex = window.history.state.batch),
              (l.pagination.current_page = l.loader.startBatchIndex + 1)),
            (l.loader.pendingBatchIndex = l.loader.startBatchIndex),
            l.load();
        },
      };
      document.addEventListener("collection:allProductsLoaded", function (t) {
        ((window.tagFiltered && 0 == Object.keys(_n.urlparams.get()).length) ||
          window.searchPerformed) &&
          (_n.qsa(".filter-option input").map(function (t) {
            _n.parents(t, ".filter-option").style.display = null;
            var e = ""
                .concat(
                  t.dataset.field
                    ? "".concat(t.dataset.field.split("~")[0], ":")
                    : ""
                )
                .concat(decodeURIComponent(t.value)),
              n = l.all_tags
                .map(function (t) {
                  return t.handle();
                })
                .includes(e.handle());
            return (
              n || (_n.parents(t, ".filter-option").style.display = "none"), n
            );
          }),
          _n
            .qsa(".filter-format-collection_links .filter-option")
            .map(function (t) {
              (t.style.display = null),
                l.all_tags
                  .map(function (t) {
                    return t.handle();
                  })
                  .includes(t.innerText.handle()) || (t.style.display = "none");
            }),
          _n.qsa(".filter-set").map(function (t) {
            t.style.display = null;
            var e =
              _n
                .qsa(".filter-option", t)
                .map(function (t) {
                  return t.style.display;
                })
                .filter(function (t) {
                  return "none" != t;
                }).length > 0;
            return e || (t.style.display = "none"), e;
          }));
      }),
        (window.Collection = l),
        document.addEventListener("DOMContentLoaded", function () {
          a.init();
        }),
        document.addEventListener("shopify:section:load", function () {
          a.init();
        });
    },
  },
  (t) => {
    t((t.s = 994));
  },
]);
